import $ from 'jquery';

// import { cookieGetItem } from '../cookie';
// import { USER_INFO } from '../constants';

export const init = () => {
  const bigQBtn = $('p[data-id="bigQBtn"]');
  const bigQ = $('div[data-id="bigQ"]');

  let isShow = false;

  bigQBtn.on('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isShow) {
      bigQ.removeClass('d-none');
    } else {
      bigQ.addClass('d-none');
    }
    isShow = !isShow;
  });

  $('.ql-tag-blot').on('click', () => {
    $('#btnWriteAnswer').trigger('click');
  })
};
